var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import PropTypes from 'prop-types';
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: props.defaultOpen,
            toggle: _this.toggle.bind(_this),
            isOpen: _this.isOpen.bind(_this),
        };
        return _this;
    }
    Accordion.getDerivedStateFromProps = function (props) {
        // Resets open items if active
        // prop is false
        if (props.active === false) {
            return { open: props.defaultOpen };
        }
        return null;
    };
    Accordion.prototype.toggle = function (item) {
        if (!this.props.active) {
            return;
        }
        this.setState(function (prevState) { return ({
            open: prevState.open.includes(item)
                ? prevState.open.filter(function (open) { return open !== item; })
                : __spread(prevState.open, [item]),
        }); });
    };
    Accordion.prototype.isOpen = function (item) {
        return !this.props.active || this.state.open.includes(item);
    };
    Accordion.prototype.render = function () {
        return this.props.children(this.state);
    };
    Accordion.propTypes = {
        /** Should the accordion behaviour be active; if false toggle with be noop and isOpen will always return `true` */
        active: PropTypes.bool,
        /** Render prop with two methods: isOpen to check if <item> is open and toogle method to change open state */
        children: PropTypes.func,
        /** Items that should be open by default */
        defaultOpen: PropTypes.array,
    };
    Accordion.defaultProps = {
        defaultOpen: [],
    };
    return Accordion;
}(React.Component));
export default Accordion;
